module.exports = __webpack_public_path__ + "img/movitone05.2feb9933.svg";